/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReviewRatingFromJSON, ReviewRatingToJSON, } from './ReviewRating';
/**
 * @export
 */
export const ProductStagingStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
};
/**
 * @export
 */
export const ProductStagingTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const ProductStagingCompetitionLevelEnum = {
    Weak: 'WEAK',
    Medium: 'MEDIUM',
    Strong: 'STRONG'
};
/**
 * @export
 */
export const ProductStagingDecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * @export
 */
export const ProductStagingPricingFailureReasonEnum = {
    InvalidAsinMarketplace: 'INVALID_ASIN_MARKETPLACE',
    MissingPayload: 'MISSING_PAYLOAD',
    ApiError: 'API_ERROR',
    RateLimit: 'RATE_LIMIT'
};
/**
 * Check if a given object implements the ProductStaging interface.
 */
export function instanceOfProductStaging(value) {
    return true;
}
export function ProductStagingFromJSON(json) {
    return ProductStagingFromJSONTyped(json, false);
}
export function ProductStagingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'status': json['status'] == null ? undefined : json['status'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'competitionLevel': json['competitionLevel'] == null ? undefined : json['competitionLevel'],
        'decision': json['decision'] == null ? undefined : json['decision'],
        'decisionReasons': json['decisionReasons'] == null ? undefined : json['decisionReasons'],
        'shippingPriceUsd': json['shippingPriceUsd'] == null ? undefined : json['shippingPriceUsd'],
        'dutyUsd': json['dutyUsd'] == null ? undefined : json['dutyUsd'],
        'shippingCarrier': json['shippingCarrier'] == null ? undefined : json['shippingCarrier'],
        'saleTaxPriceUsd': json['saleTaxPriceUsd'] == null ? undefined : json['saleTaxPriceUsd'],
        'totalCostUsd': json['totalCostUsd'] == null ? undefined : json['totalCostUsd'],
        'currencyRate': json['currencyRate'] == null ? undefined : json['currencyRate'],
        'minProfit': json['minProfit'] == null ? undefined : json['minProfit'],
        'minProfitUsd': json['minProfitUsd'] == null ? undefined : json['minProfitUsd'],
        'maxProfit': json['maxProfit'] == null ? undefined : json['maxProfit'],
        'maxProfitUsd': json['maxProfitUsd'] == null ? undefined : json['maxProfitUsd'],
        'minSellingPrice': json['minSellingPrice'] == null ? undefined : json['minSellingPrice'],
        'minSellingPriceUsd': json['minSellingPriceUsd'] == null ? undefined : json['minSellingPriceUsd'],
        'maxSellingPrice': json['maxSellingPrice'] == null ? undefined : json['maxSellingPrice'],
        'maxSellingPriceUsd': json['maxSellingPriceUsd'] == null ? undefined : json['maxSellingPriceUsd'],
        'referralFee': json['referralFee'] == null ? undefined : json['referralFee'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'sellingPriceNetOfVat': json['sellingPriceNetOfVat'] == null ? undefined : json['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': json['sellingPriceNetOfVatUsd'] == null ? undefined : json['sellingPriceNetOfVatUsd'],
        'vatAmount': json['vatAmount'] == null ? undefined : json['vatAmount'],
        'vatAmountUsd': json['vatAmountUsd'] == null ? undefined : json['vatAmountUsd'],
        'profit': json['profit'] == null ? undefined : json['profit'],
        'profitUsd': json['profitUsd'] == null ? undefined : json['profitUsd'],
        'sellingPrice': json['sellingPrice'] == null ? undefined : json['sellingPrice'],
        'sellingPriceUsd': json['sellingPriceUsd'] == null ? undefined : json['sellingPriceUsd'],
        'appliedPromotionShare': json['appliedPromotionShare'] == null ? undefined : json['appliedPromotionShare'],
        'searchResultId': json['searchResultId'] == null ? undefined : json['searchResultId'],
        'skuSegment': json['skuSegment'] == null ? undefined : json['skuSegment'],
        'reviewRating': json['reviewRating'] == null ? undefined : ReviewRatingFromJSON(json['reviewRating']),
        'pricingFailureReason': json['pricingFailureReason'] == null ? undefined : json['pricingFailureReason'],
        'purchasePriceUsd': json['purchasePriceUsd'] == null ? undefined : json['purchasePriceUsd'],
        'targetCountryCode': json['targetCountryCode'] == null ? undefined : json['targetCountryCode'],
        'title': json['title'] == null ? undefined : json['title'],
        'targetBrandSeller': json['targetBrandSeller'] == null ? undefined : json['targetBrandSeller'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'category': json['category'] == null ? undefined : json['category'],
        'leafCategories': json['leafCategories'] == null ? undefined : json['leafCategories'],
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'lowestPrice': json['lowestPrice'] == null ? undefined : json['lowestPrice'],
        'buyboxPrice': json['buyboxPrice'] == null ? undefined : json['buyboxPrice'],
        'totalOfferCount': json['totalOfferCount'] == null ? undefined : json['totalOfferCount'],
        'fbaOfferCount': json['fbaOfferCount'] == null ? undefined : json['fbaOfferCount'],
        'amazonOfferCount': json['amazonOfferCount'] == null ? undefined : json['amazonOfferCount'],
        'primeOfferCount': json['primeOfferCount'] == null ? undefined : json['primeOfferCount'],
        'failed': json['failed'] == null ? undefined : json['failed'],
        'readyForProcess': json['readyForProcess'] == null ? undefined : json['readyForProcess'],
    };
}
export function ProductStagingToJSON(json) {
    return ProductStagingToJSONTyped(json, false);
}
export function ProductStagingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'asin': value['asin'],
        'status': value['status'],
        'targetMarket': value['targetMarket'],
        'competitionLevel': value['competitionLevel'],
        'decision': value['decision'],
        'decisionReasons': value['decisionReasons'],
        'shippingPriceUsd': value['shippingPriceUsd'],
        'dutyUsd': value['dutyUsd'],
        'shippingCarrier': value['shippingCarrier'],
        'saleTaxPriceUsd': value['saleTaxPriceUsd'],
        'totalCostUsd': value['totalCostUsd'],
        'currencyRate': value['currencyRate'],
        'minProfit': value['minProfit'],
        'minProfitUsd': value['minProfitUsd'],
        'maxProfit': value['maxProfit'],
        'maxProfitUsd': value['maxProfitUsd'],
        'minSellingPrice': value['minSellingPrice'],
        'minSellingPriceUsd': value['minSellingPriceUsd'],
        'maxSellingPrice': value['maxSellingPrice'],
        'maxSellingPriceUsd': value['maxSellingPriceUsd'],
        'referralFee': value['referralFee'],
        'referralFeeUsd': value['referralFeeUsd'],
        'sellingPriceNetOfVat': value['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': value['sellingPriceNetOfVatUsd'],
        'vatAmount': value['vatAmount'],
        'vatAmountUsd': value['vatAmountUsd'],
        'profit': value['profit'],
        'profitUsd': value['profitUsd'],
        'sellingPrice': value['sellingPrice'],
        'sellingPriceUsd': value['sellingPriceUsd'],
        'appliedPromotionShare': value['appliedPromotionShare'],
        'searchResultId': value['searchResultId'],
        'skuSegment': value['skuSegment'],
        'reviewRating': ReviewRatingToJSON(value['reviewRating']),
        'pricingFailureReason': value['pricingFailureReason'],
        'purchasePriceUsd': value['purchasePriceUsd'],
        'targetCountryCode': value['targetCountryCode'],
        'title': value['title'],
        'targetBrandSeller': value['targetBrandSeller'],
        'brand': value['brand'],
        'category': value['category'],
        'leafCategories': value['leafCategories'],
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'lowestPrice': value['lowestPrice'],
        'buyboxPrice': value['buyboxPrice'],
        'totalOfferCount': value['totalOfferCount'],
        'fbaOfferCount': value['fbaOfferCount'],
        'amazonOfferCount': value['amazonOfferCount'],
        'primeOfferCount': value['primeOfferCount'],
        'failed': value['failed'],
        'readyForProcess': value['readyForProcess'],
    };
}
